import axios from 'axios'

export default {
    //Admin
    getAccounts: (filters) => axios.post('account/list',filters),
    store: (data) => axios.post('account/store',data),
    update: (data) => axios.post('account/update',data),
    inactive: (data) => axios.post('account/inactive',data),
    active: (data) => axios.post('account/active',data),

    // Al users
    getInfo: () => axios.get('account/info'),    
    setPassword: (data) => axios.post('users/update-password', data),

    recoverPasswordLink: (data) => axios.post('account/recover-password-link',data),
}